/* eslint-disable consistent-return */
import { createSelector } from 'reselect';
import transform from 'lodash/transform';
import omitBy from 'lodash/omitBy';
import Progress from 'redux-progress';
import FormValidationError from 'model/hams/FormValidationError';
import { State } from 'model/State';
import { checkIsAllowedTaxExemptionType } from '../../../../../utils';

const errorsToOmit = [
  'validate.order.cart.multicurrency.lockeditem.on.purchaser.mismatch',
  'validate.order.cart.multicurrency.lockeditem.on.techContact.mismatch',
  'validate.order.cart.multicurrency.purchaser.country.locked',
  'validate.order.cart.multicurrency.technicalContact.country.locked',
  'validate.order.cart.contact.technicalContactSameAsBilling',
];

export default createSelector(
  (s: State) => s.checkout.contacts.submitProgress.error,
  (error) => {
    if (error instanceof FormValidationError) {
      const validityObj = transform(
        omitBy(error, (errorObj: any) => errorsToOmit.includes(errorObj.errorKey)),
        (result, errorObj: any) => {
          /* eslint-disable no-param-reassign */
          if (errorObj.field === 'cartContactEntity') {
            let updatedFieldName = errorObj.defaultMessage.split('.');
            if (checkIsAllowedTaxExemptionType(updatedFieldName[1])) {
              updatedFieldName[1] = 'taxExemptions';
            }
            updatedFieldName = updatedFieldName.join('.');
            result[updatedFieldName] = Progress.fail({
              text: errorObj.errorKey || errorObj.defaultMessage,
            });
          } else {
            result[errorObj.field] = Progress.fail({
              text: errorObj.errorKey || errorObj.defaultMessage,
            });
          }
        },
        {},
      );

      const orgDetailsList: string[] = [];
      Object.keys(validityObj).forEach((key) => {
        const keyParts = key.split('.');
        if (keyParts[1] === 'taxExemptions') {
          orgDetailsList.push(keyParts[0]);
        }
      });
      Object.keys(validityObj).forEach((key) => {
        const keyParts = key.split('.');
        if (keyParts[1] === 'taxId' && orgDetailsList.includes(keyParts[0])) {
          delete validityObj[key];
        }
      });

      return validityObj;
    }
  },
);
